export const joinWithCommas = (values: string[]) => {
  const valuesCopy = [...values];
  if (valuesCopy.length === 0) return '';
  if (valuesCopy.length === 1) return values[0];
  if (valuesCopy.length === 2) return `${values[0]} and ${values[1]}`;

  const last = valuesCopy.pop();
  return `${valuesCopy.join(', ')} and ${last}`;
};
